/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HelpdeskGetDocumentPathParameters } from 'api/actions/helpdesk-get-document/helpdesk-get-document-path-parameters';
import { HelpdeskGetDocumentResponse } from 'api/actions/helpdesk-get-document/helpdesk-get-document-response';

type HelpdeskGetDocumentQueryParameters = Record<string, any>;

/**
 * The path of the HelpdeskGetDocument action.
 */
export const helpdeskGetDocumentActionPath = new SweetPath<keyof HelpdeskGetDocumentPathParameters>(
  '/help-desk/document/{documentId}.{ext}',
  { path: '{param}' }
);

/**
 * Creates a contextualized HelpdeskGetDocument actions.
 */
export default function createHelpdeskGetDocumentAction(axios: AxiosInstance) {
  return function helpdeskGetDocumentAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HelpdeskGetDocumentPathParameters;
    query?: HelpdeskGetDocumentQueryParameters;
  }) {
    const path = helpdeskGetDocumentActionPath.insert(parameters);

    return axios.get<HelpdeskGetDocumentResponse, HelpdeskGetDocumentResponse>(path, { params: query, headers });
  };
}
